import { languageOptions, type LanguageOption } from 'BrokerTsLib/src/enums'
import React, { useContext } from 'react'

export type TranslateFunction = (key: string, defaultValue?: string) => string
interface ITranslationsContext {
  translations: Record<string, string>
  translate: TranslateFunction
  reload: () => void
  getLanguage: () => LanguageOption
  translateFormat: (key: string, defaultValue: string, params?: Record<string, React.ReactNode>) => React.ReactNode
}


export const TranslationsContext = React.createContext<ITranslationsContext>({
  translations: {},
  translate: (key: string, defaultValue?: string) => defaultValue ?? key,
  reload: () => { },
  getLanguage: () => languageOptions[0],
  translateFormat: (key: string, defaultValue: string, _params?: Record<string, React.ReactNode>) => defaultValue ?? key,
})

export const useTranslationsContext = () => {
  const context = useContext(TranslationsContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useTranslationsContext must be used within a TranslationsProvider!')
  }

  return context
}